import styles from './SensorCard.module.css';

export const SensorCardSkeleton = () => {
  return <div className={styles.skeleton} />;
};
